import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';
import {
  IndexResponseType,
  NormalizedIndexResponseType,
} from '../../types/apiTypes';
import { getIndexParametersAsQueryParams } from '@/api/apiHelpers';

const useIndex = (internalIndexValues: IndexResponseType | null) => {
  return useQuery({
    queryKey: ['priceIndex', internalIndexValues],
    queryFn: async (): Promise<NormalizedIndexResponseType | null> => {
      if (internalIndexValues === null) {
        return null;
      }
      if (internalIndexValues.index_id === null || !internalIndexValues.index_id) return null;

      const parameters = getIndexParametersAsQueryParams(internalIndexValues);

      const URL = `${
        import.meta.env.VITE_API_INDEX_NORMALIZED_URL
      }?${parameters}`;

      const { data } = await axiosClient.get<NormalizedIndexResponseType>(URL);

      return data;
    },
  });
};

export default useIndex;
